import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

import "./theme/fonts.css";
import "./theme/tokens.css";
import "./core/ui/components/PinPad.css";
import "./core/ui/till/till.css";
import "./core/ui/till/corrections.css";
import "./core/ui/backoffice/menu-admin.css";
import "./core/platform/receipt/print.css";
import "./app.css";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
